import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface clearNotificationDataState {
  isLoading: boolean
  loadingError: string | undefined
  httpStatus: number | undefined
}

// Initial state of the slice
const initialState: clearNotificationDataState = {
  isLoading: false,
  loadingError: undefined,
  httpStatus: undefined
}

// Slice to return from action
export const clearNotificationDataStateListState = createSlice({
  name: 'clearNotificationDataStateData',
  initialState,
  reducers: {
    ClearNotificationLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        httpStatus: 0
      }
    },
    ClearNotificationUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    ClearNotificationErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  ClearNotificationLoadingAction,
  ClearNotificationUpdateAction,
  ClearNotificationErrorAction
} = clearNotificationDataStateListState.actions

export default clearNotificationDataStateListState.reducer
